<template>
    <div id="newsSpecial">
        <div>
            <ul>
                <router-link tag="li" to="news/cont?id=2">
                    <img src="../../../assets/imgs/news/news3.png">
                    <div class="newText">
                        <div>
                            十二五水专项“城市供水管网智能管理系统关键技术研究与示范”课题
                        </div>
                        <p>2019-07-10</p>
                    </div>
                </router-link>
                <router-link tag="li" to="news/cont?id=0">
                    <img src="../../../assets/imgs/news/news2.png">
                    <div class="newText">
                        <div>
                            追梦——三博水科技秦皇岛团建
                        </div>
                        <p>2019-07-07</p>
                    </div>
                </router-link>
                <router-link tag="li" to="news/cont?id=1">
                    <img src="../../../assets/imgs/news/news1.png">
                    <div class="newText">
                        <div>
                            天津三博水科技有限公司“供水管网智能化管理关键技术研究与应用”项目成功通过科技成果评价
                        </div>
                        <p>2019-06-27</p>
                    </div>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'List1',
}
</script>

<style scoped>
    #newsSpecial{
        background: #fff;
        padding: 35px 0 25px;
    }
    #newsSpecial>div{
        width: 1100px;
        padding: 0 10px;
        margin: 0 auto;
    }
    #newsSpecial ul{
        overflow: hidden;
    }
    #newsSpecial li{
        margin-right:30px;
        float: left;
        width: calc((100% - 96px) / 3);
        border: 1px solid #ddd;
        padding: 5px;
        cursor: pointer;
    }
    #newsSpecial li>img{
        width: 100%;
        height: 200px;
    }
    #newsSpecial li:last-child{
        margin-right: 0;
    }
    .newText{
        font-size: 11px;
        padding: 10px 5px;
    }
    /* 最多显示两行，超出隐藏 */
    .newText>div{ 
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;     /*设置行数*/
        -webkit-box-orient: vertical;
        height: 40px;
    }
    .newText>p{
        font-size: 10px;
        color: #909090;
        margin-top: 10px;
    }
</style>
